import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'widgets/Select/Select';
import ColorPicker from './ColorPicker';
import { brightness } from '../../utils/colors';

export const ITEM_UNAVAILABLE_ERROR = 'ITEM_UNAVAILABLE';

export default class Derivatives extends PureComponent {
  static propTypes = {
    childSku: PropTypes.string,
    derivativesTree: PropTypes.array.isRequired,
    dimensions: PropTypes.array.isRequired,
    sku: PropTypes.string.isRequired,
    options: PropTypes.array,
    addOptions: PropTypes.func.isRequired,
    fetchProductBasicInfo: PropTypes.func.isRequired,
    clearOptions: PropTypes.func.isRequired,
    productWarnings: PropTypes.object,
  };

  static defaultProps = {
    options: [],
    productWarnings: {},
  };

  componentDidUpdate() {
    const { sku, childSku } = this.props;
    if (childSku) {
      this.refresh(childSku);
    } else {
      this.refresh(sku);
    }
  }

  refresh = (sku) => {
    this.props.fetchProductBasicInfo(sku, this.props.sku);
  };

  chooseOption = (level, name, value, colorCode) => {
    const { sku } = this.props;
    if (value === '') {
      return this.props.clearOptions(sku, level);
    }
    return this.props.addOptions(sku, level, value, colorCode);
  };

  isDisabled = (index) => {
    if (index === 0) {
      return false;
    }
    const { options } = this.props;
    if (options[index - 1]) {
      return false;
    }
    return true;
  };

  displayError = () => {
    const { productWarnings, childSku } = this.props;
    if (productWarnings[childSku] && productWarnings[childSku].includes(ITEM_UNAVAILABLE_ERROR)) {
      return (
        <span className="bop-basketControls__error">
          This product type is out of stock. Please choose another from the other available options.
        </span>
      );
    }
    return null;
  };

  isLastOption = (level) => {
    const { dimensions } = this.props;
    return level === (dimensions.length - 1);
  };

  isOptionDisabled = (level, index) => {
    const { options } = this.props;
    let { derivativesTree } = this.props;
    let node;
    const currentSelection = options.slice(0, level);
    for (const option of currentSelection) {
      node = derivativesTree.find((el) => el.index === parseInt(option, 10));
      if (level === currentSelection.length) {
        return !node.children.find((el) => el.index === index);
      }
      derivativesTree = node.children;
    }
    return false;
  };

  sortByBrightness = (colors) =>
    colors.map((color, index) => ({ ...color, brightness: brightness(`#${color.colourCode}`), index }))
      .sort((a, b) => b.brightness - a.brightness);

  render = () => {
    const { dimensions, options } = this.props;
    return dimensions.map((item, level) =>
      (
        <li className={`bop-basketControls__item--derivatives ${item.name}`} key={item.name}>
          {item.name !== 'Colour' ? (
            <Select
              name={item.name}
              onChange={(name, value) => this.chooseOption(level, name, value)}
              disabled={this.isDisabled(level)}
              value={options[level] || ''}
              options={item.options && item.options.reduce((acc, curr, index) => {
                acc.push({
                  name: curr.value,
                  value: index.toString(),
                  disabled: this.isOptionDisabled(level, index),
                });
                return acc;
              }, [{
                name: 'Choose option',
                value: '',
              }])
              }
            />
          )
            : (
              <ColorPicker
                chosenElementIndex={options[level]}
                onChange={(name, value) => this.chooseOption(level, name, value)}
                options={item.options && this.sortByBrightness(item.options).reduce((acc, curr) => {
                  acc.push({
                    name: curr.value,
                    value: curr.index.toString(),
                    colourCode: curr.colourCode,
                    disabled: this.isOptionDisabled(level, curr.index),
                    checked: curr.index.toString() === options[level],
                  });
                  return acc;
                }, [])}
              />
            )}
          {this.isLastOption(level) && this.displayError()}
        </li>
      ),
    );
  };
}
